import { render } from "./Profile.vue?vue&type=template&id=2821cedc"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"
script.render = render

export default script